//
// NumericAxisOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";
import "../core/styles/LineAttributes";

var NumericAxisOptions = createModule("gtl::NumericAxisOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        thresholdMin: 6,
        minorGridAttributes: 1,
        tickValuePriority: 2,
        minorTicks: 2,
        minorGrid: 2,
        tickValueList: [6],
        thresholdMax: 6,
        viewMax: 6,
        viewMin: 6,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default NumericAxisOptions;
